import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pushMessageVenueSearch',
  pure: false
})

  export class PushMessageVenueSearchPipe implements PipeTransform {
  transform(data: any[], searchTerm: string): any[] {
    if (searchTerm) {
      searchTerm = searchTerm.toLowerCase();
      return data.filter(item => {
        return item.name.toLowerCase().indexOf(searchTerm) !== -1 || item.name.toLowerCase().indexOf(searchTerm) !== -1;
      });
    } else {
      return data;
    }
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/push-messages/push-message-details/push-message-details-venue-search.pipe.ts